export default __webpack_public_path__ + "static/media/iphone.1d3e1787.png";